<template>
  <div class="headquarters">
    <slot name="headquarters-items" />
  </div>
</template>

<script>

export default {
  name: 'headquarters',
}
</script>

<style scoped lang="scss">
.headquarters {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2rem;
}
</style>
